// These are used in SCSS variable via gulp.
// When changed, restart gulp.

const animationSettings = {
    animationDuration: 5000,
    animationStages: [
        {
            zoomLevel: "0.1"
        },
        {
            zoomLevel: "0.001"
        },
        {
            zoomLevel: "0.0001"
        },
        {
            zoomLevel: "0.00005"
        },
        {
            zoomLevel: "0.00001"
        }
    ],
    finalStageZoomLevel: "0.000005"
};

module.exports = animationSettings;



// WEBPACK FOOTER //
// ./src/config/animation-settings.js